import { useQuery } from '@tanstack/react-query';
import { useTenant } from '@/hooks/use-tenant';
import { websiteBannerControllerGetBannerById } from '@/generated/korza-api-client';
import type { WebsiteBannerDto } from '@/generated/korza-api-client/types.gen';

export function useGetWebsiteBanner() {
  const tenant = useTenant();
  const bannerId = tenant.websiteBannerId ?? null;

  return useQuery<WebsiteBannerDto | null>({
    queryKey: ['website-banner', bannerId],
    queryFn: async (): Promise<WebsiteBannerDto | null> => {
      if (!bannerId) return null;
      const res = await websiteBannerControllerGetBannerById({
        path: { bannerId },
      });
      return res.data ?? null;
    },
    enabled: bannerId != null,
  });
}
